module.exports = __webpack_public_path__ + "static/media/ClosedCycles.b87d7c39.svg";